import { useI18n, type BiText } from '@longnan/ui';
import { GROUP_MESSAGES } from './messages';

type Vars = Record<string, string | number>;

/**
 * 站点级 t()：先查本站中文文案，再回落共享中文文案
 * （App 已用 ChineseSurface 把共享取值锁定为中文）。支持 {var} 插值。
 */
export function useT() {
  const base = useI18n();
  return {
    ...base,
    t: (key: string, vars?: Vars) => {
      const raw = GROUP_MESSAGES.zh[key] ?? base.t(key);
      if (!vars) return raw;
      return Object.entries(vars).reduce((acc, [k, v]) => acc.replaceAll(`{${k}}`, String(v)), raw);
    },
  };
}

/** 图片路径：基于构建 base（./），静态部署与子路径部署都可用。 */
export function assetUrl(local: string): string {
  return `${import.meta.env.BASE_URL}${local}`;
}

/** 把 messages 中的一个键转为多语言对象。本站只填 zh，其余语种由 pick() 回落链取到中文。 */
export function biOf(key: string): BiText {
  return { zh: GROUP_MESSAGES.zh[key] ?? key };
}
